import cn from "classnames"
import { Fragment, useMemo } from "react"

import style from "modules/PsyProfile/components/Info/components/Methods/style.module.scss"
import { Psychologist } from "utils/interfaces"
import { HelpTooltip } from "components"
import { Text } from "ui-kit/components-branded/Text"

export const Methods = ({ psy }: { psy: Psychologist }) => {
    const methods = useMemo(() => psy.methods.slice(0, 5), [psy.methods])

    return (
        <>
            {methods.length > 0 && (
                <div
                    className={cn(style.container, {
                        [style["is-multi"]]: methods.length > 1,
                    })}
                    data-testid="psy-profile-methods"
                >
                    <div className={style.list}>
                        {methods.map((item, index) => {
                            return (
                                <div key={item.code} className={style.itemWrapper}>
                                    {index !== 0 && methods.length > 1 && (
                                        <div className={style.dots}>
                                            <div className={style.dotsInner} />
                                        </div>
                                    )}
                                    <span className={style.item}>
                                        <Text className={style.name}>{item.short_name}</Text>
                                        <span className={style.tooltip}>
                                            <HelpTooltip
                                                placement="top"
                                                overlay={
                                                    <>
                                                        <div className={style.tooltipName}>
                                                            {item.name}
                                                        </div>
                                                        <div className={style.tooltipDescription}>
                                                            {item.description}
                                                        </div>
                                                    </>
                                                }
                                            />
                                        </span>
                                    </span>
                                </div>
                            )
                        })}
                    </div>
                </div>
            )}
        </>
    )
}
